import _ from 'lodash';
import { Logger } from '@/helpers/log';

const logger = new Logger('legacy:migration:sync');

function getByKey(key, ref, resources) {
  const resource = resources.find((r) => r[key] === ref);
  return resource;
}

export function syncLegacy(hints, actual) {
  const showProperties = {};
  const linkProperties = {};
  const createFilters = {};
  const linkFilters = {};
  const createKpis = {};
  hints.forEach(((hint) => {
    const {
      id, filters, properties, kpis,
    } = hint;
    Object.entries(filters).forEach(([k, v]) => {
      let link = getByKey('id', k, actual.filters);
      if (link !== undefined) { return; }
      link = getByKey('name', v.$description, actual.filters);
      if (link && link.expression === v.where) {
        logger.info('request re-ref of filters from-to', id, link, v);
        linkFilters[k] = link.id;
      } else {
        logger.info('request creation of filter', id, v);
        createFilters[k] = v;
      }
    });
    Object.entries(properties).forEach(([k, v]) => {
      const link = getByKey('name', k, actual.properties);
      if (!link) {
        logger.error('unable to recreate orphaned property', id, v);
        return;
      }
      if (link.hidden) {
        logger.info('request show of property', id, v);
        showProperties[v.$id] = v;
      }
      if (link.id !== v.$id) {
        logger.info('request re-ref of property from-to', id, link, v);
        linkProperties[v.$id] = link.id;
      }
    });
    Object.entries(kpis).forEach(([k, v]) => {
      const link = getByKey('$id', k, actual.kpis);
      if (link !== undefined) { return; }
      logger.info('request creation of kpi', id, v);
      createKpis[k] = v;
    });
  }));
  const count = (
    Object.keys(showProperties).length
    + Object.keys(linkProperties).length
    + Object.keys(createFilters).length
    + Object.keys(linkFilters).length
    + Object.keys(createKpis).length
  );
  const actions = {
    showProperties,
    linkProperties,
    linkFilters,
    createFilters,
    createKpis,
    dirty: count > 0,
  };
  logger.debug('collected actions', actions);
  return actions;
}

function syncRef(o, find, replace) {
  if (!o) {
    return o;
  }
  if (Array.isArray(o)) {
    return o.map((i) => syncRef(i, find, replace));
  }
  if (typeof o === 'object') {
    return Object.entries(o).reduce((s, [k, v]) => ({
      ...s, [k]: syncRef(v, find, replace),
    }), {});
  }
  if (typeof o === 'string' && o.endsWith(find)) {
    const replaced = `${o.substring(0, -find.length)}${replace}`;
    logger.debug('linking', o, replaced);
    return replaced;
  }
  return o;
}
export function syncRefs(resources, references) {
  const changed = [];
  const updated = resources.map((r) => {
    let synced = _.cloneDeep(r);
    Object.entries(references).forEach(([find, replace]) => {
      synced = syncRef(synced, find, replace);
    });
    if (!_.isEqual(r, synced)) {
      logger.info('linked', synced);
      changed.push(synced);
    }
    return synced;
  });
  return { changed, updated };
}
